import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface Props {
    searchInput: string
    onSearchInputChange: (v: string) => void
    typeInput: string
    onTypeInputChange: (v: string) => void
    overdueOnly: boolean
    onOverdueOnlyChange: (v: boolean) => void
    onReset: () => void
    hasActive: boolean
}

// Filter bar tab "Chờ tôi đánh giá". Thuần presentational; debounce ở AwaitingList.
const AwaitingFilters = ({
    searchInput,
    onSearchInputChange,
    typeInput,
    onTypeInputChange,
    overdueOnly,
    onOverdueOnlyChange,
    onReset,
    hasActive,
}: Props) => {
    const { t } = useTranslation('rating')

    return (
        <div className="flex flex-wrap items-end gap-2 rounded-lg border border-gray-200 bg-gray-50/60 p-3">
            {/* <label> bọc <Input> để liên kết ngầm, khỏi phát sinh id. */}
            <label className="min-w-[200px] flex-1">
                <span className="mb-1 block text-xs text-gray-500">
                    {t('filter.search')}
                </span>
                <Input
                    type="search"
                    value={searchInput}
                    placeholder={t('filter.search_placeholder')}
                    onChange={(e) => onSearchInputChange(e.target.value)}
                />
            </label>
            <label className="min-w-[160px]">
                <span className="mb-1 block text-xs text-gray-500">
                    {t('filter.ticket_type')}
                </span>
                <Input
                    type="search"
                    value={typeInput}
                    placeholder={t('filter.ticket_type_placeholder')}
                    onChange={(e) => onTypeInputChange(e.target.value)}
                />
            </label>

            <button
                type="button"
                aria-pressed={overdueOnly}
                className={cn(
                    'h-9 rounded border px-3 text-xs transition-colors',
                    overdueOnly
                        ? 'border-amber-400 bg-amber-50 font-medium text-amber-700'
                        : 'border-gray-200 text-gray-500 hover:border-gray-300'
                )}
                onClick={() => onOverdueOnlyChange(!overdueOnly)}
            >
                {t('filter.overdue_only')}
            </button>

            {hasActive && (
                <Button
                    variant="ghost"
                    size="sm"
                    className="h-9 text-xs"
                    onClick={onReset}
                >
                    {t('filter.reset')}
                </Button>
            )}
        </div>
    )
}

export default AwaitingFilters
